module.exports = __webpack_public_path__ + "img/program-opened.99b72e4b.png";